import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { OrderNumberFormatConfig } from './order-number-format-config';
import { AdminContextProvider } from '../../../context/admin-context';

export function initOrderNumberFormatConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('order-number-format-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        root.render(
          v2Component(
            <AdminContextProvider>
              <OrderNumberFormatConfig />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
